module.exports = __webpack_public_path__ + "media/images/regpic1-a85d9196.svg";